module.exports = __webpack_public_path__ + "img/10.ca734bb2.png";